// extracted by mini-css-extract-plugin
module.exports = {"switchContainer":"Switch_switchContainer__8WPAl","switchInput":"Switch_switchInput__Dwi73","switchSlider":"Switch_switchSlider__z_uGb"};